<!-- <footer id="main-footer">
    <div id="footer-body" class="container">
        <div class="row wrapper-row">
            <div class="col-auto col_1" *ngIf="company$ | async as company">
                <h4 class="title h-false">{{ company.comName }}</h4>
                <ul>
                    <li>
                        <span>{{'footer.lbl.006' | translate}}</span>
                        <span>{{ company.addr1 + '' +  company.addr2}}</span>
                    </li>
                    <li>
                        <span>{{'footer.lbl.005' | translate}}</span>
                        <span>{{ company.comOwner }}</span>
                    </li>
                    <li>
                        <span>{{'footer.lbl.008' | translate}}</span>
                        <span>{{ company.comTaxNo }}</span>
                    </li>
                    <li>
                        <span>{{'footer.lbl.011' | translate}}</span>
                        <span>{{ company.comTsNo }}</span>
                    </li>
                    <li>
                        <span style="margin-right: 0px;"></span>
                        <span>
                            신한은행 <b>100-029-980601</b> {{ company.comName }}
                        </span>
                    </li>
                </ul>
            </div>
            <div class="col-auto col_2">
                <h4 class="title h-false">{{'footer.lbl.004' | translate}}</h4>
                <ul>
                    <ng-container *ngFor="let item of footerMenu;">
                        <ng-container *ngIf="item.menuLv === '1'">

                            <ng-container *ngIf="!item.helpUrl">
                                <li><a [routerLink]="item.linkInfo">{{ item.prgName }}</a></li>
                            </ng-container>
                            <ng-container *ngIf="item.helpUrl">
                                <li><a target="_blank" [href]="item.helpUrl">{{ item.prgName }}</a></li>
                            </ng-container>

                        </ng-container>
                    </ng-container>
                </ul>
            </div>
            <div class="col-auto col_3">
                <h4 class="title h-false">{{'footer.lbl.013' | translate}}</h4>
                <ul>
                    <ng-container *ngFor="let item of footerMenu;">
                        <ng-container *ngIf="item.menuLv === '0'">
                            <ng-container *ngIf="item.popupYn==='Y'">
                                <li><a (click)="handleOnClickFooterMenuItem()">{{ item.prgName }}</a></li>
                            </ng-container>
                            <ng-container *ngIf="item.helpUrl&&item.popupYn==='N'">
                                <li><a [href]="item.helpUrl" target="_blank">{{ item.prgName }}</a></li>
                            </ng-container>
                            <ng-container *ngIf="!item.helpUrl&&item.popupYn==='N'">
                                <li><a [routerLink]="item.linkInfo">{{ item.prgName }}</a></li>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </ul>
            </div>
            <div class="col-auto col_4">
                <h4 class="title h-false">{{'footer.lbl.014' | translate}}</h4>
                <ul *ngIf="company$ | async as company">
                    <li>
                        <span>{{'footer.lbl.010'| translate}}</span>
                        <span> {{ company.tel }}</span>
                    </li>
                    <li>
                        <span>{{'footer.lbl.007'| translate}}</span>
                        <span> {{ company.fax }}</span>
                    </li>
                    <li>
                        <span>{{'footer.lbl.012'| translate}}</span>
                        <span> {{ company.eMail }}</span>
                    </li>
                </ul>
                <div class="col-md-auto socials row">
                    <a class="col-auto fb" href="#" target="_blank">
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                            <path
                                d="M21.1575 17.5414L21.7779 13.5041H17.9028V10.8889C17.9028 9.78178 18.4469 8.7128 20.1744 8.7128H21.9306V5.27679C21.9306 5.27679 20.3367 5 18.8095 5C15.6217 5 13.541 6.92799 13.541 10.4308V13.5041H10V17.5414H13.541V27H17.9028V17.5414H21.1575Z"
                                fill="#2A2E46" />
                        </svg>
                    </a>

                    <a class="col-auto insta" href="#" target="_blank">
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                            <path
                                d="M20.7679 10.2117C20.1798 10.2117 19.7072 10.684 19.7072 11.2612C19.7072 11.849 20.1798 12.3213 20.7679 12.3213C21.356 12.3213 21.8286 11.849 21.8286 11.2612C21.8181 10.684 21.3455 10.2117 20.7679 10.2117Z"
                                fill="#2A2E46" />
                            <path
                                d="M16.0735 11.5658C13.6265 11.5658 11.6417 13.5495 11.6417 15.995C11.6417 18.4404 13.6265 20.4241 16.0735 20.4241C18.5204 20.4241 20.5052 18.4404 20.5052 15.995C20.5052 13.56 18.5204 11.5658 16.0735 11.5658ZM16.0735 18.8393C14.5087 18.8393 13.238 17.5693 13.238 16.0055C13.238 14.4416 14.5087 13.1716 16.0735 13.1716C17.6382 13.1716 18.9089 14.4416 18.9089 16.0055C18.9089 17.5693 17.6382 18.8393 16.0735 18.8393Z"
                                fill="#2A2E46" />
                            <path
                                d="M19.5916 25H12.4084C9.42591 25 7 22.5755 7 19.5948V12.4052C7 9.42449 9.42591 7 12.4084 7H19.5916C22.5741 7 25 9.42449 25 12.4052V19.5843C25 22.5755 22.5741 25 19.5916 25ZM12.4084 8.70029C10.3606 8.70029 8.69078 10.3691 8.69078 12.4157V19.5948C8.69078 21.6414 10.3606 23.3102 12.4084 23.3102H19.5916C21.6394 23.3102 23.3092 21.6414 23.3092 19.5948V12.4052C23.3092 10.3586 21.6394 8.6898 19.5916 8.6898H12.4084V8.70029Z"
                                fill="#2A2E46" />
                        </svg>
                    </a>

                    <a class="col-auto youtube" href="#" target="_blank">
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                            <path
                                d="M27 13.4323C27 10.9825 24.8412 9 22.1737 9H9.82625C7.15875 9 5 10.9825 5 13.4323V18.7106C5 21.1603 7.15875 23.1429 9.82625 23.1429H22.1737C24.8412 23.1429 27 21.1603 27 18.7106V13.4323ZM19.74 16.4629L14.1988 18.9758C13.9788 19.0894 13.25 18.9379 13.25 18.7106V13.5459C13.25 13.3186 13.9925 13.1671 14.2125 13.2807L19.5063 15.9325C19.7263 16.0588 19.96 16.3619 19.74 16.4629Z"
                                fill="#2A2E46" />
                        </svg>

                    </a>

                    <a class="col-auto kakao" href="#" target="_blank">
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M15.75 8C10.3652 8 6 11.4418 6 15.6875C6 18.4324 7.82493 20.8409 10.5701 22.2009C10.4208 22.716 9.6104 25.5144 9.57815 25.7343C9.57815 25.7343 9.55874 25.8995 9.66571 25.9625C9.77268 26.0255 9.89849 25.9765 9.89849 25.9765C10.2052 25.9337 13.4556 23.6505 14.0182 23.254C14.5803 23.3336 15.159 23.375 15.75 23.375C21.1348 23.375 25.5 19.9332 25.5 15.6875C25.5 11.4418 21.1348 8 15.75 8Z"
                                fill="#2A2E46" />
                            <path
                                d="M10.3594 18.3711C10.0492 18.3711 9.79687 18.1301 9.79687 17.8339V14.4922H8.91919C8.61478 14.4922 8.36719 14.2451 8.36719 13.9414C8.36719 13.6377 8.61487 13.3906 8.91919 13.3906H11.7996C12.104 13.3906 12.3516 13.6377 12.3516 13.9414C12.3516 14.2451 12.1039 14.4922 11.7996 14.4922H10.9219V17.8339C10.9219 18.1301 10.6696 18.3711 10.3594 18.3711ZM15.2917 18.3638C15.0572 18.3638 14.8777 18.2685 14.8236 18.1153L14.5451 17.3861L12.8299 17.3861L12.5511 18.1157C12.4972 18.2686 12.3179 18.3638 12.0833 18.3638C11.96 18.3639 11.838 18.3374 11.7258 18.2861C11.5707 18.2146 11.4217 18.0179 11.5925 17.4874L12.938 13.9459C13.0327 13.6766 13.3206 13.3991 13.687 13.3907C14.0544 13.399 14.3423 13.6766 14.4373 13.9465L15.7822 17.4864C15.9534 18.0181 15.8044 18.2149 15.6493 18.2862C15.537 18.3374 15.4151 18.3639 15.2917 18.3638C15.2917 18.3638 15.2916 18.3638 15.2917 18.3638ZM14.2493 16.3898L13.6875 14.7937L13.1256 16.3898H14.2493ZM16.6875 18.2891C16.3902 18.2891 16.1484 18.0577 16.1484 17.7734V13.9531C16.1484 13.6429 16.406 13.3906 16.7226 13.3906C17.0392 13.3906 17.2969 13.6429 17.2969 13.9531V17.2578H18.4922C18.7894 17.2578 19.0312 17.4892 19.0312 17.7734C19.0312 18.0577 18.7894 18.2891 18.4922 18.2891H16.6875ZM19.8125 18.3638C19.5023 18.3638 19.25 18.1115 19.25 17.8013V13.9531C19.25 13.6429 19.5023 13.3906 19.8125 13.3906C20.1228 13.3906 20.375 13.6429 20.375 13.9531V15.1621L21.9444 13.5927C22.0251 13.512 22.136 13.4676 22.2564 13.4676C22.3968 13.4676 22.5378 13.5282 22.6435 13.6337C22.742 13.7322 22.8008 13.8588 22.8089 13.9903C22.817 14.123 22.7729 14.2446 22.6848 14.3328L21.4029 15.6145L22.7875 17.4488C22.8322 17.5076 22.8648 17.5748 22.8833 17.6463C22.9019 17.7178 22.906 17.7923 22.8955 17.8655C22.8855 17.9387 22.861 18.0092 22.8236 18.0728C22.7861 18.1365 22.7364 18.1921 22.6773 18.2365C22.58 18.3104 22.4611 18.3503 22.3389 18.35C22.2518 18.3504 22.1657 18.3304 22.0877 18.2916C22.0097 18.2527 21.9418 18.1962 21.8896 18.1264L20.5704 16.3785L20.3752 16.5737V17.801C20.3751 17.9502 20.3157 18.0932 20.2102 18.1987C20.1047 18.3042 19.9617 18.3636 19.8125 18.3638Z"
                                fill="white" />
                        </svg>

                    </a>
                </div>
            </div>
        </div>
    </div>

    <div id="footer-copyright">
        <div class="container">
            <div class="row">
                <div class="col-lg-auto copyright" *ngIf="company$ | async as company">© Copyright 2019 {{ company.comName }} All rights reserved.</div>
                <div class="col-lg external-policies">
                    <ul class="row">
                    </ul>
                </div>
            </div>
        </div>
    </div>

</footer> -->


<div class="footer" id="footer">
    <div class="ftbanner">
        <div class="contain">
            <img src="./assets/lasted/img/logo-f.svg" alt="">
        </div>
    </div>
  <div class="contain">
    <div class="row ftCont">
        <div class="footerInfo">
            <div>
                <dl>
                    <dt>{{ company.comName }}</dt>
                    <dd>{{'footer.lbl.006' | translate}} {{ company.addr1 + '' + company.addr2}}</dd>
                    <dd>대표이사 도영기</dd>
                    <dd>사업자등록 번호 220-88-77829</dd>
                    <dd>통신판매업신고번호 2016-서울금천-0844호</dd>
                    <dd>신한은행 100-029-980601 ㈜아이엠글로벌넷</dd>
                </dl>
            </div>
        </div>
        <div class="footerMenu">
            <dl>
              <dt>Abouts</dt>
              <!-- <ng-container *ngFor="let item of footerMenu;">
                <ng-container *ngIf="item.menuLv == '1'">
                  <dd><a [routerLink]="item.linkInfo">{{ item.prgName }}</a></dd>
                </ng-container>
              </ng-container> -->
              <dd><a [routerLink]="'/about/who-iam'">Who IAM</a></dd>
              <dd><a [routerLink]="'/about/how-iam'">How IAM</a></dd>
              <dd><a [routerLink]="'/about/what-iam'">What IAM</a></dd>
              <dd><a [routerLink]="'/about/why-iam'">Why IAM</a></dd>
            </dl>
            <dl>
              <dt>{{'footer.lbl.013' | translate}}</dt>
              <ng-container *ngFor="let item of footerMenu;">
                <ng-container *ngIf="item.menuLv == '0'">
                    <ng-container *ngIf="!item.helpUrl&&item.popupYn==='N'">
                        <dd>
                            <ng-container *ngIf="item.linkInfo === '/servicePage/privacy-policy'">
                                <a href="/policy.html">{{item.prgName}}</a>
                            </ng-container>
                            <ng-container *ngIf="item.linkInfo !== '/servicePage/privacy-policy'">
                                <a [routerLink]="item.linkInfo">{{item.prgName}}</a>
                              </ng-container>
                        </dd>
                    </ng-container>
                    <ng-container *ngIf="item.helpUrl&&item.popupYn==='N'">
                        <dd><a [href]="item.helpUrl" target="_blank">{{ item.prgName }}</a></dd>
                    </ng-container>
                </ng-container>    
              </ng-container>
            </dl>
            <dl>
              <dt>{{'footer.lbl.014' | translate}}</dt>
              <dd>{{'footer.lbl.010' | translate}} 02-6959-5699</dd>
              <dd>{{'report.member.042' | translate}} 02-558-8526</dd>
              <dd>{{'my-office.register.lbl.051' | translate}} iam.korea@iamglobalnet.com</dd>
            </dl>
        </div>
    </div>
    <div class="row border-top ftCopy">
      <p>ⓒ 2024. IAM GLOBALNET INC. AII Rights Reserved.</p>
    </div>
  </div>
</div>
